import { NoSsr as MuiNoSsr } from '@mui/base';

/**
 * @deprecated Unsupported component: This component is not supported in the Unify design system and will be removed in the next major.
 * Please reach out to us in #unify-design-system-support with your designer if you have a use case for this component.
 */
export const NoSsr = MuiNoSsr;
